import { jsx } from "react/jsx-runtime";
import React from "react";
import Box from "../Box";
import Spinner from "../Spinner";
const LOADER_WRAPPER_SX = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};
const LOADER_WRAPPER_FH_SX = {
  ...LOADER_WRAPPER_SX,
  height: "100dvh"
};
const DEFAULT_DELAY = 300;
const DEFAULT_BG = "elevation0";
const DEFAULT_SIZE = "xxxxl";
const LoadingIndicator = (props) => {
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    setShow(false);
    const timer = setTimeout(() => {
      setShow(true);
    }, props.delay ?? DEFAULT_DELAY);
    return () => {
      clearTimeout(timer);
    };
  }, [props?.delay]);
  const spinnerSize = props.size ?? DEFAULT_SIZE;
  if (!show)
    return null;
  return /* @__PURE__ */ jsx(
    Box,
    {
      sx: props.fullHeight ? LOADER_WRAPPER_FH_SX : LOADER_WRAPPER_SX,
      bg: props.ignoreBg ? void 0 : props.bg ?? DEFAULT_BG,
      color: props.color,
      className: props.className,
      children: /* @__PURE__ */ jsx(Spinner, { size: spinnerSize })
    }
  );
};
var LoadingIndicator_default = LoadingIndicator;
export {
  LoadingIndicator_default as default
};
